import BaseComponent from '../../../js/base-component';
import { Splide } from '@splidejs/splide/build/complete/complete';

class GallerySlider extends BaseComponent {
    constructor(element) {
        super(element);

        this.gallerySliderContainer = this.element.querySelector('.u-gallery-slider__slider');
        this.galleryNumbersContainer = this.element.querySelector('#galleryNumbers');

        if (this.gallerySliderContainer) {
            this.splide = new Splide(this.gallerySliderContainer, {
                perPage: 1,
                perMove: 1,
                arrows: true,
                pagination: false,
                breakpoints: {
                    767: {
                        arrows: false,
                        // pagination: true,
                    },
                },
            });

            this.splide.mount();
        }

        this.update();
        this.splide.on( 'move', this.update );
    }

    // onInit() {}

    update = () => {
        let slides = this.element.querySelectorAll('.splide__slide');
        let captionHeight = 26;
        let setHeight = false;

        if (!setHeight) {
            slides.forEach( (ele) => {
                let fc = ele.querySelector('figcaption');

                if (fc && fc.clientHeight > captionHeight) {
                    captionHeight = fc.clientHeight;
                }

                setHeight = true;
            });
        }

        this.galleryNumbersContainer.style.bottom = (captionHeight - 26) + 'px';
        this.galleryNumbersContainer.textContent = `Bild ${ this.splide.index + 1 } von ${ this.splide.length } |`;
    }
}

export default {
  name: 'GallerySlider',
  definition: GallerySlider
};